import React, { useEffect, useState } from "react";
import "./ownership.scss";
import Accordion from "react-bootstrap/Accordion";
import { Card } from "react-bootstrap";
import errorLogo from "../../../../../images/Error.svg";
import check from "../../../../../images/check.svg";
import { OwnersForAdditionalInformation } from "../ownershipForm/OwnershipInformationdata";
import { Question } from "../../../../../models/ComplianeQuestionarie";
import { QuestionnaireComponent } from "dynamic-questionarie";
import { AxiosError } from "axios";
import { catchError } from "../../../../../utils/Utils";
import Service from "../../../../../services";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import FinSpinner from "../../../../../commonfields/FinSpinner";
import ReactFileViewer from "../../../../../commonfields/ReactFileViewer";


interface OwnershipInformationUIprops {
  OwnersInformation: any[];
  individualsData: Question[];
  getownersInformation: (ownerId: string, groupId: string) => void;
  // onSaveQuestion: (question: Question, oldAnswer: any) => void;
  // markAsPrimary: (ownerInfo: any) => void;
  // addPerson: (row:any, groupType: string) =>void;
  entityType: any;
  clientStockData: any;
}
interface ownersList {
  id: number;
  heading: string;
  value: string;
}
type ObjectKey = keyof OwnersForAdditionalInformation;


const additionalOwnersInformation: ownersList[] = [
  { id: 0, heading: "Key Ownership", value: "keyOwner" },
  { id: 1, heading: "Managing Partners", value: "managingMember" },
  { id: 2, heading: "Authorized Signers", value: "authorizedSigner" },
];
const additionalOwnersInformationForCorp: ownersList[] = [
  { id: 0, heading: "Key Ownership", value: "keyOwner" },
  { id: 1, heading: "Corporate Officers", value: "managingMember" },
  { id: 2, heading: "Authorized Signers", value: "authorizedSigner" },
];
const additionalOwnersInformationForLLC: ownersList[] = [
  { id: 0, heading: "Key Ownership", value: "keyOwner" },
  { id: 1, heading: "Managing Members", value: "managingMember" },
  { id: 2, heading: "Authorized Signers", value: "authorizedSigner" },
];



const OwnershipInformationUI: React.FC<OwnershipInformationUIprops> = (
  props: OwnershipInformationUIprops
) => {
  const [selectedOwner, setSelectedOwner] = useState<any>();
  const [previousOwnerSelected, setPreviousOwnerSelected] = useState<any>();
  const [ownersInformation, setownersInformation] = useState<any>();
  const [refreshQuestionsData, setRefreshQuestionsData] = useState(false);
  const [fileHandleModal, setfileHandleModal] = useState<boolean>(false);
  const [fileData, setFiledata] = useState<any>(null);
  const [loader, setLoader] = useState<boolean>(false);
  const service = new Service();

  useEffect(() => {
    setownersInformation(props.individualsData);
    setRefreshQuestionsData(true);
    setTimeout(() => {
      setRefreshQuestionsData(false);
    }, 300);
  }, [props.individualsData]);

  const getOwnersInfo = (ownersInfo: string) => {
    if (ownersInfo) {
      const key = ownersInfo.split('@@@');

      setSelectedOwner(key[0]);
      setPreviousOwnerSelected(key[0]);
      if (previousOwnerSelected !== key[0]) {
        props.getownersInformation(key[0].slice(0, -1), key[1]);
      }
    } else {
      setSelectedOwner(null);
    }
  };

  const selectingEventId = (
    eventKey: OwnersForAdditionalInformation,
    ownersListing: ownersList
  ) => {
    if (ownersListing.heading == "Key Ownership") {
      if (eventKey.groupId) {
        const primaryOwner = props.OwnersInformation.filter(
          (n) => n.groupId == eventKey.groupId
        ).filter((m) => m.primary);
        if (primaryOwner.length > 0) return primaryOwner[0].ownerId;
        else return eventKey.ownerId;
      } else {
        return eventKey.ownerId;
      }
    } else {
      return eventKey.ownerId;
    }
  };

  // const fileClick =  (question:any)=>{
  //  console.log(question);
  // }

  // const onSaveQuestion = (question: Question, oldAnswer: any) => {
  //   props.onSaveQuestion(question, oldAnswer);
  // };

  const getPercentage = (owner: OwnersForAdditionalInformation, ownerInfo: any) => {
    if (owner.groupId && ownerInfo == 0) {

      let sum = 0;
      props.OwnersInformation.map((n: OwnersForAdditionalInformation) => {
        if (n.groupId == owner.groupId) {
          sum += n.actualPercentage
        }
      })
      return sum
    } else {
      return owner.actualPercentage
    }
  }

  const getAllOwnersOfGroup = (owner: OwnersForAdditionalInformation) => {
    if (owner.groupId) {
      return props.OwnersInformation.filter(
        (m: OwnersForAdditionalInformation) => m.groupId == owner.groupId
      );
    } else {
      return [owner];
    }
  };

  const nameContainer = (value: any) => {
    return (
      <p className="sideliners">
        {(value.firstName ? value.firstName : "") + (value.lastname ? " " + value.lastname : "")}

      </p>
    );
  };

  const checkConditionForPrimary = (owner: OwnersForAdditionalInformation) => {
    if (owner.groupId) {
      const group = props.OwnersInformation.filter(
        (m: OwnersForAdditionalInformation) => m.groupId == owner.groupId
      );
      if (group.length === 2) {
        return true
      }
      else {
        return false
      }
    }
  }
  const tittleContainer = (value: any, ownerInfo: any) => {
    return (
      <>
        {(value.title ? value.title : "--")}

      </>
    );
  };
  // const makeAsPrimary = (ownerInfo: any) => {
  //   props.markAsPrimary(ownerInfo);
  // };

  const openFileViewHandler = () => {
    setfileHandleModal(!fileHandleModal);
  };

  const fileClick = (file: any) => {
    setLoader(true);
    // console.log(file)
    service.getFile(file?.filePath).then((response: any) => {
      // console.log(response.data);
      if (response.data) {
        const data = { ...response.data, uri: response.data.fileContent }
        setFiledata(data);
      }
      openFileViewHandler();
    }).catch((error: AxiosError) => {
      catchError(error, true);
    }).finally(() => {
      setLoader(false)
    })
  }

  const ownersAccordion = (ownersListing: ownersList, index: number) => {
    const groupIds: string[] = [];
    const myVar = ownersListing.value as ObjectKey;
    return (
      <div>
        {props.OwnersInformation.filter(
          (n: OwnersForAdditionalInformation) => n[myVar]
        ).map((m: OwnersForAdditionalInformation, i) => {
          if (ownersListing.heading == "Key Ownership") {
            if (m.groupId != null) {
              if (m.groupId && groupIds.indexOf(m.groupId) > -1) {
                return null;
              }
              if (m.groupId && groupIds.indexOf(m.groupId) == -1) {
                groupIds.push(m.groupId);
              }
            }
          }

          return (
            <Card key={i}>
              <Accordion.Item
                as={Card.Header}
                variant="link"
                eventKey={`${selectingEventId(m, ownersListing) + ownersListing.id + '@@@' + ownersListing.heading
                  }`}
              >
                <Accordion.Header
                  className={
                    selectedOwner ==
                      selectingEventId(m, ownersListing) + ownersListing.id
                      ? "accordionOpen"
                      : ""
                  }>
                  {<div key={index} className="ownersInformationContainer">

                    {props.clientStockData?.publicTradedCompany != "true" ?

                      <div className="namesContainer">

                        {ownersListing.heading == "Key Ownership" ? (
                          getAllOwnersOfGroup(m).map(
                            (n: OwnersForAdditionalInformation) => (
                              <div className="namebox" key={n.ownerId}>
                                {nameContainer(n)}
                                {n.primary && checkConditionForPrimary(m) ? (
                                  <div className="primaryBox">
                                    <p>PRIMARY</p>
                                  </div>
                                ) : (
                                  n.groupId && checkConditionForPrimary(m) &&
                                  selectedOwner ==
                                  selectingEventId(m, ownersListing) +
                                  ownersListing.id && (
                                    <div
                                      className={`primaryBox makeAsDefault`}>

                                      <p>Mark as Primary</p>
                                    </div>
                                  )
                                )}
                              </div>
                            )
                          )
                        ) : (
                          <div className="namebox">{nameContainer(m)}</div>


                        )}

                      </div> : (
                        <div className="namesContainer">
                          <div className="namebox">{nameContainer(m)}</div> </div>


                      )}


                    <div className="ownershipContainer">
                      {ownersListing.value == "authorizedSigner"
                        || (ownersListing.value == "managingMember") ?
                        <p className="sideliners">Title:&nbsp;{tittleContainer(m, ownersListing.id)}

                        </p> :
                        <p className="sideliners">Ownership:{getPercentage(m, ownersListing.id)}</p>}
                    </div>

                    {ownersListing.heading == "Authorized Signers" ?
                      (
                        <div className="processContainer">

                          <p className="sideliners">
                            {m.primarySigner && <input type="checkbox" checked disabled />}

                            &nbsp; Primary Signatory</p>

                        </div>

                      ) : ""}
                    {((ownersListing.heading == "Key Ownership" &&

                      getAllOwnersOfGroup(m).find((m2: OwnersForAdditionalInformation) => m2.primary)) || m).completed ? (
                      <div className="processContainer">
                        <img src={check} alt="complete" />
                        <p className="process complete">Complete</p>
                      </div>
                    ) : (
                      <div className="processContainer">
                        <img src={errorLogo} alt="Incomplete" />
                        <p className="process incomplete">Incomplete</p>
                      </div>
                    )}

                  </div>}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="ownershipModule">
                    {selectedOwner ==
                      selectingEventId(m, ownersListing) + ownersListing.id && (
                        <QuestionnaireComponent
                          questionsData={ownersInformation ? ownersInformation : []}
                          refreshQuestionsData={refreshQuestionsData}
                          disableFields={true}
                          onNextPage={undefined}
                          onPreviousPage={undefined}
                          displayNextPrevButtons={false}
                          formName={`QuestionnaireForm${m.ownerId}`}
                          canAddGroupQuestions={false}
                          onAddGroupQuestion={function (
                            questionGroupUuid: any,
                            currentSerialNumber: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          onRemoveGroupQuestion={function (
                            questionGroupUuid: any,
                            selectedSerialNumber: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          onClickFile={fileClick}
                        />



                      )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Card>
          );
        })}
      </div>
    );
  };

  const isEntityType = (type: string) => {
    return props.entityType?.text === type;
  }

  return (
    <div>
      <p>Please provide additional information for the following Individuals</p>
      {loader && <FinSpinner />}

      <Accordion defaultActiveKey="0" onSelect={(e: any) => getOwnersInfo(e)}>
      {(((isEntityType('Sole Proprietorship')) || (isEntityType('C-Corp')) || (isEntityType('Other')) || (isEntityType('Corporation'))?
          additionalOwnersInformationForCorp : (isEntityType('Partnership')) ?
            additionalOwnersInformation:additionalOwnersInformationForLLC)).map((m, index) => {
              const myVar = m.value as ObjectKey;
              if (props.clientStockData?.publicTradedCompany == "true" && m.heading === 'Key Ownership') {
                return '';
              }
              return (
                <div className="ownershipListing" key={index}>
                  {props.OwnersInformation.filter(
                    (n: OwnersForAdditionalInformation) => n[myVar]
                  ) && (
                      <>
                        {" "}
                        <h1 className="ownersListingHeading">{m.heading}</h1>
                        <hr />
                      </>
                    )}
                  {ownersAccordion(m, index)}
                  {/* {((m.value !== "keyOwner")?
              <div className="addPersonContainer">                
               <button onClick = {() =>props.addPerson(m.value, m.heading)}>Add Person</button></div>:"")} */}


                </div>
              );

            })}
      </Accordion>
      <div className="fileViewerModalContainer">
        <Modal
          className=" mw-100 w-50 fileViewerModalWrapper"
          isOpen={fileHandleModal}
          fade={false}
          toggle={openFileViewHandler}
        >
          <ModalHeader toggle={openFileViewHandler} className="tc_heading">
            <span>{fileData?.fileName} </span>
          </ModalHeader>
          <ModalBody>
            <div className="TC_fileView">
              {loader ? (
                <FinSpinner />
              ) : (
                fileData ? <ReactFileViewer
                  fileDocument={fileData}
                /> : ""
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};

export default OwnershipInformationUI;
